import type { Lead } from '../../../../shared/types';
import { isDesktop, onBreakpointChange } from '../../ui/breakpoint';
import { section } from '../../ui/components';
import { h } from '../../ui/dom';
import { stopMap } from '../../ui/stopMap';

/** Own the map across the exact 1024px boundary, disposing the old instance on every crossing. */
export const dueMap = () => {
  const el = h('aside', { class: 'brief__side' });
  let leads: Lead[] = [];
  let map: ReturnType<typeof stopMap> | null = null;
  const rebuild = () => {
    map?.dispose();
    map = isDesktop() ? stopMap() : null;
    el.hidden = !map;
    el.replaceChildren(...(map ? [section({ title: 'On the map' }, map.el)] : []));
    if (map) void map.show(leads);
  };
  rebuild();
  const off = onBreakpointChange(rebuild);
  return { el, show: (next: Lead[]) => { leads = next; if (map) void map.show(leads); },
    dispose: () => { off(); map?.dispose(); } };
};
